import { Flex } from "antd";
import { FC } from "react";
import { Payment } from "tm-shared/types";
import { formatUAHNarrow } from "tm-shared/utils";

import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { StyledPaymentItem } from "@/pages/Dashboard/DashboardTabs/Payments/components/PaymentItem/Styled";

interface PaymentItemProps {
    payment: Payment;
    userId: string;
}

export const PaymentItem: FC<PaymentItemProps> = ({ payment, userId }) => {
    return (
        <StyledPaymentItem>
            <PrimaryText>{payment.consignmentId}</PrimaryText>

            {payment?.payer && payment?.payer !== userId && (
                <Flex gap={16}>
                    <SecondaryText fontSize={16}>Платник:</SecondaryText>

                    <PrimaryText fontSize={16} $textColor="accent">
                        {payment?.payerFullName}
                    </PrimaryText>
                </Flex>
            )}

            <Flex gap={8}>
                <SecondaryText fontSize={16}>Оплата:</SecondaryText>

                <PrimaryText $textColor="accent" fontSize={18}>
                    {formatUAHNarrow(payment.paidAmount ?? 0)}
                </PrimaryText>
            </Flex>
        </StyledPaymentItem>
    );
};
